// extracted by mini-css-extract-plugin
export default {"tooltip":"KV-z","arrow":"LV-z"};